import { useState } from 'react'
import { BottomSheet, Button } from '@healingpaper/cell'
import Checkbox from '@/components/atomic/atoms/Checkbox'

interface Props {
  isOpen: boolean
  onClose: () => void
  onAgree: () => void
}

const IdentityVerificationConsentModal = ({ isOpen, onClose, onAgree }: Props) => {
  const [isAgreed, setIsAgreed] = useState(false)

  return (
    <BottomSheet
      visible={isOpen}
      onClose={onClose}
      buttonStack={
        <div className="px-6 mb-6">
          <Button size="Large" onClick={onAgree} disabled={!isAgreed} className="w-full">
            동의하고 본인인증하기
          </Button>
        </div>
      }
    >
      <div className="flex flex-col py-6">
        <div className="px-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">휴대폰 본인 인증</h2>

          <p className="text-sm text-gray-700 mb-6 leading-relaxed">
            이름, 휴대폰 번호, 생년월일이 변경된 경우
            <br />
            본인 인증을 통해 회원 정보를 수정할 수 있습니다.
          </p>

          <div className="bg-gray-100 rounded-lg p-4 space-y-4 mb-6">
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">수집 항목</h3>
              <p className="text-sm text-gray-600">
                이름, 성별, 생년월일, 휴대폰 번호, DI(중복가입확인정보),
                <br />
                내/외국인 정보, 휴대폰 본인 인증 결과
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">이용 목적</h3>
              <p className="text-sm text-gray-600">회원 본인 인증</p>
            </div>
          </div>

          <p className="text-sm text-gray-500 mb-6 leading-relaxed">
            본인 확인 기관 NICE 평가정보로부터 정보를 제공받아
            <br />
            인증된 회원 정보를 업데이트하고 수집하는데 동의합니다.
          </p>

          <div className="border-t border-gray-200 pt-4">
            <Checkbox id="agree-all" checked={isAgreed} onChangeCheckbox={setIsAgreed}>
              <span className="font-medium text-gray-900">동의하기</span>
            </Checkbox>
          </div>
        </div>
      </div>
    </BottomSheet>
  )
}

export default IdentityVerificationConsentModal
